import { Observable, of, throwError } from 'rxjs';

export class GenericErrorHandler {

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  static handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      if (error.status === 0){
        error.error = 'Website unavailable, please try again later';
      }
      // TODO: send the error to remote logging infrastructure
      if (error.status === 500){
        error.error = error.error || 'Server error, please try again later';
        return throwError(error);
      }

      // TODO: better job of transforming error for user consumption
      // this.log(`${operation} failed: ${error.message}`);
      return throwError(error || 'Server error');
      // Let the app keep running by returning an empty result.
      // return of(result as T);
    };
  }
}

